export default "__VITE_ASSET__C4HH2UR$__"